import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import radius from '../../theme/styles';
import { injectIntl } from 'react-intl';

import Icon from '../Icon/Icon';
import P from '../P/P';
import messages from './messages';

const DragAndDropArea = styled.div`
  background-color: ${props => props.theme.colors.gray};
  outline: 2px dashed #fff;
  outline-offset: -10px;
  /* padding: 48px 20px 100px; */
  min-width: 100px;
  text-align: center;
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  ${radius};

  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  svg {
    width: 100%;
    min-width: 50px;
    margin-top: -40px;
  }

  use {
    transition: all 0.25s ease-in-out;
    fill: ${props => props.theme.colors.primary};
  }

  & ${P} {
    text-align: center;
    font-family: ${props => props.theme.fonts.PannoTextNormal};
    font-weight: 400;
    font-size: ${props => props.theme.fonts.sizeButton};
    padding: 0 20px;
  }

  &:hover {
    background-color: ${props => props.theme.colors.lightgray};
    outline: 2px dashed ${props => props.theme.colors.success};
    /* outline-offset: -20px; */

    & ${P} {
      color: ${props => props.theme.colors.success};
    }

    & use {
      fill: ${props => props.theme.colors.success};
    }
  }

  ${props =>
    props.active &&
    css`
      background-color: ${props.theme.colors.lightgray};
      outline: 2px dashed ${props.theme.colors.success};
      outline-offset: -20px;

      & ${P} {
        color: ${props.theme.colors.success};
      }

      & use {
        fill: ${props.theme.colors.success};
      }
    `};

  ${props =>
    props.reject &&
    css`
      background-color: ${props.theme.colors.lightgray};
      outline: 2px dashed ${props.theme.colors.danger};
      outline-offset: -2px;

      & ${P} {
        color: ${props.theme.colors.danger};
      }

      & use {
        fill: ${props.theme.colors.danger};
      }
    `};

  ${props =>
    props.accepted &&
    css`
      &,
      &:hover {
        background-color: ${props.theme.colors.primary50};
        outline: 2px dashed ${props.theme.colors.primary};
        outline-offset: -10px;
        position: relative;
        opacity: 0.9;

        & ${P} {
          color: ${props.theme.colors.white};
        }

        & use {
          fill: ${props.theme.colors.primary};
        }
      }
    `};
`;

const ProgressValue = styled.div`
  font-weight: 600;
  font-family: ${props => props.theme.fonts.fontfaceBold};
  letter-spacing: 0.4px;
  font-size: ${props => props.theme.fonts.sizeH2};
  line-height: 1em;
  color: ${props => props.theme.colors.white};
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 0;
`;

const Progress = styled.div`
  display: none;
  background-color: ${props => props.theme.colors.primary85};
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  transform: scaleY(0);

  ${props =>
    props.calcPercent &&
    css`
      transform: scaleY(${props.calcPercent / 100});
    `};
  transition: transform 0.2s ease-in-out;
  z-index: -1;

  ${props =>
    props.accepted &&
    css`
      display: block;
    `};
`;

const statusObjects = {
  default: {
    icon: 'plus',
    label: messages.uploadDefault
  },
  isDragActive: {
    icon: 'plus',
    label: messages.uploadActive,
    active: true
  },
  isDragReject: {
    icon: 'plus',
    label: messages.uploadReject,
    reject: true
  },
  acceptedFiles: {
    icon: 'checkmark-circle-blue',
    label: messages.uploadProgress,
    percentValue: true,
    accepted: true
  }
};

class DragAndDrop extends React.Component {
  render() {
    const { status, calcPercent, progressLabel, intl } = this.props;
    const statusObject = statusObjects[status];
    const {
      label,
      icon,
      iconColor,
      percentValue,
      ...styleProps
    } = statusObject;
    const defaultMessage = intl.formatMessage(label);
    const message = progressLabel || defaultMessage;
    return (
      <DragAndDropArea {...styleProps}>
        {percentValue &&
          calcPercent >= 0 &&
          calcPercent < 100 && (
            <ProgressValue {...styleProps}>{calcPercent} %</ProgressValue>
          )}
        {calcPercent === 100 && <Icon id={icon} fillColor={iconColor} />}
        {!percentValue && <Icon id={icon} fillColor={iconColor} />}
        <P lighter textcenter>
          {message}
        </P>
        <Progress {...styleProps} calcPercent={calcPercent} />
      </DragAndDropArea>
    );
  }
}

DragAndDrop.defaultProps = {
  calcPercent: 0,
  status: 'default'
};

DragAndDrop.propTypes = {
  calcPercent: PropTypes.number,
  status: PropTypes.oneOf([
    'default',
    'isDragActive',
    'isDragReject',
    'acceptedFiles'
  ])
};

export default injectIntl(DragAndDrop);



// WEBPACK FOOTER //
// ./src/components/DragAndDrop/DragAndDrop.js